var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_299",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 44C19.3667 42.8333 15.5417 40.175 12.525 36.025C9.50833 31.875 8 27.2667 8 22.2V10L24 4L40 10V22.2C40 27.2667 38.4917 31.875 35.475 36.025C32.4583 40.175 28.6333 42.8333 24 44ZM24 39.8C27.4667 38.7 30.3333 36.5 32.6 33.2C34.8667 29.9 36 26.2333 36 22.2V12.75L24 8.25L12 12.75V22.2C12 26.2333 13.1333 29.9 15.4 33.2C17.6667 36.5 20.5333 38.7 24 39.8ZM20 32H28C28.5667 32 29.0417 31.8083 29.425 31.425C29.8083 31.0417 30 30.5667 30 30V24C30 23.4333 29.8083 22.9583 29.425 22.575C29.0417 22.1917 28.5667 22 28 22V20C28 18.9 27.6083 17.9583 26.825 17.175C26.0417 16.3917 25.1 16 24 16C22.9 16 21.9583 16.3917 21.175 17.175C20.3917 17.9583 20 18.9 20 20V22C19.4333 22 18.9583 22.1917 18.575 22.575C18.1917 22.9583 18 23.4333 18 24V30C18 30.5667 18.1917 31.0417 18.575 31.425C18.9583 31.8083 19.4333 32 20 32ZM22 22V20C22 19.4333 22.1917 18.9583 22.575 18.575C22.9583 18.1917 23.4333 18 24 18C24.5667 18 25.0417 18.1917 25.425 18.575C25.8083 18.9583 26 19.4333 26 20V22H22Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.2cf3c191126dad7e1d824f56f270bcf5.svg";
export { ForwardRef as ReactComponent };